
const economicFillIndex = r => require.ensure([], () => r(require('@/page/fillEconomicIndicators/economicFillIndex')), 'economicFillIndex');
const enterpriseEconomicList = r => require.ensure([], () => r(require('@/page/fillEconomicIndicators/enterpriseEconomicList')), 'enterpriseEconomicList');
const economicSituationSupervision = r => require.ensure([], () => r(require('@/page/fillEconomicIndicators/economicSituationSupervision')), 'economicSituationSupervision');
const economicFillDetail = r => require.ensure([], () => r(require('@/page/fillEconomicIndicators/economicFillDetail')), 'economicFillDetail');

const fillEconomicIndicatorsRouter = {
  path: '',
  name: '规上企业经济指标填报',
  component: economicFillIndex,
  meta: {
    right: [],
    isShowMenu: false,
  },
  children: [
    { path: '/enterpriseEconomicList', component: enterpriseEconomicList, name: '规上企业经济指标填报', meta: { right: [], isShowMenu: false, keepAlive: false }},
    { path: '/economicSituationSupervision', component: economicSituationSupervision, name: '规上企业经济指标填报情况', meta: { right: [], isShowMenu: false, keepAlive: false }},
    { path: '/economicFillDetail', component: economicFillDetail, name: '企业经济指标填报', meta: { right: [], isShowMenu: false, keepAlive: false }},
  ]
};
export default fillEconomicIndicatorsRouter;


